import script from "./OperatorApplicationSideMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorApplicationSideMenu.vue?vue&type=script&lang=ts&setup=true"

import "./OperatorApplicationSideMenu.vue?vue&type=style&index=0&id=e8c026ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8c026ac"]])

export default __exports__